import React, { Component } from "react";
import Head from "next/head";
import Layout from "../../container";
import { Grid } from "semantic-ui-react";
import { LandingFooter } from "../../pagecomponents/Welcome";

class Fairhousing extends Component {
  render() {
    return (
      <div className="home-wrapper">
        <Head>
          <meta charSet="UTF-8" />
          <title>Fair housing</title>
          <meta
            property="og:image"
            content={
              process.env.NEXT_PUBLIC_CDN_ID + "static/images/seoimg.png"
            }
          />
        </Head>

        <div className="static_content_main">
          <Layout search={true} nhmap={false}>
            <Grid
              stackable
              style={{ margin: "0 auto", maxWidth: "1280px" }}
              className="detail_nh_top"
            >
              <div className="aboutus_main">
                <h1>Houseberry Fair Housing Policy</h1>
                <p>
                  Houseberry is committed to promoting fair and equitable
                  housing opportunities for all users of our platform. We expect
                  every user to comply with applicable fair housing laws and
                  regulations when using Houseberry's services.
                </p>
                <p>
                  Houseberry does not tolerate any form of discrimination based
                  on race, color, religion, sex, marital status, sexual
                  orientation, gender identity, familial status, age, national
                  origin, citizenship or immigration status, physical or mental
                  disability, recovery from substance abuse, military status,
                  source of income, or any other protected class as defined by
                  federal, state, and local laws. It is the responsibility of
                  each user to ensure they do not engage in any discriminatory
                  practices or violate fair housing laws when using Houseberry's
                  platform.
                </p>
                <p>
                  We emphasize the following principles for all users of
                  Houseberry:
                </p>
                <p>
                  Compliance with Fair Housing Laws: Users must abide by all
                  applicable federal, state, and local fair housing laws when
                  using Houseberry's platform.
                </p>
                <p>
                  Non-Discriminatory Practices: Users must not discriminate
                  against any individual or group based on their protected class
                  status. This includes but is not limited to providing equal
                  access to housing opportunities, services, and information
                  without regard to protected characteristics.
                </p>
                <p>
                  Respectful and Inclusive Interactions: Users should engage in
                  respectful and inclusive interactions with other users,
                  avoiding any language or behavior that may be discriminatory
                  or offensive.
                </p>
                <p>
                  Reporting Violations: Users are encouraged to report any
                  suspected violations of fair housing laws or discriminatory
                  practices they encounter on Houseberry's platform. Houseberry
                  will investigate and take appropriate actions based on the
                  information provided.
                </p>
                <p>
                  It is essential for all users to understand that Houseberry is
                  a platform that facilitates the exchange of housing
                  information and services. While Houseberry does not directly
                  control the actions of individual users, we are committed to
                  promoting fair housing and will take necessary steps to
                  address any reported violations and ensure compliance with
                  fair housing laws.
                </p>
                <p>
                  By using Houseberry's platform, users acknowledge and agree to
                  comply with this fair housing policy and the applicable fair
                  housing laws. Failure to adhere to these guidelines may result
                  in consequences, including but not limited to restrictions or
                  termination of access to Houseberry's services.
                </p>
                <p>
                  Please note that this fair housing policy does not constitute
                  legal advice, and users are encouraged to seek legal guidance
                  to ensure their compliance with all applicable fair housing
                  laws and regulations.
                </p>
              </div>
            </Grid>
          </Layout>
          <LandingFooter />
        </div>
      </div>
    );
  }
}

export default Fairhousing;
